export default __webpack_public_path__ + "static/media/falcon-logo.b42e85d2.png";